<template>
  <div>
    <ElForm
      label-position="top"
      require-asterisk-position="right"
      @submit.prevent="submit"
    >
      <ElFormItem
        label="Passwort bestätigen"
        class="my-5"
        :error="errors.password?.[0]"
      >
        <ElInput
          v-model="form.password"
          data-testid="confirm-input"
          type="password"
          show-password
        />
        <div class="w-full mt-2 text-gray-600 text-xs">
          Zum Fortfahren {{ duzen('musst du dein', 'müssen Sie Ihr') }} Passwort bestätigen.
        </div>
      </ElFormItem>

      <div class="text-right">
        <AppButton
          type="primary"
          data-testid="confirm-button"
          :handler="submit"
        >
          Bestätigen
        </AppButton>
      </div>
    </ElForm>
  </div>
</template>

<script setup lang="ts">
import AppButton from '@/application/components/ui/AppButton.vue';
import { ElForm, ElFormItem, ElInput } from 'element-plus';
import { useForm } from "@/api/lib/integration";
import { confirmPassword } from "@/api/auth/authApi";
import { useBaseDataStore } from '@/user/store/baseDataStore.ts';

const emit = defineEmits(['confirmed']);

const { duzen } = useBaseDataStore();

const { form, errors, submit } = useForm(
  confirmPassword,
  { password: '' },
  () => emit('confirmed'),
);

defineExpose({ form, errors });
</script>
